<template lang="html">
  <svg v-if="isSVG" v-bind:class="name + ' material-icons'"><use v-bind:xlink:href="'#'+name"></use></svg>
  <i v-else class="material-icons">{{ name }}</i>
</template>

<script>
const svgIcons = [
  'icon-solar-cloudy',
  'icon-plant-id',
  'icon-key-figures',
  'icon-tag',
  'icon-calendar',
  'icon-stop-logbook',
  'icon-contracts-db',
  'icon-reporter',
  'icon-data',
  'shape-smile',
  'shape-smile-high',
  'shape-smile-medium',
  'shape-smile-low',
  'shape-smile-good',
  'icon-handle',
  'icon-pin',
  'icon-notification',
  'icon-arrow-back',
  'icon-wind-force',
  'icon-wind',
  'icon-hydro',
  'icon-solar',
  'icon-reglages',
  'icon-power',
  'icon-compass',
  'icon-intrusion',
  'icon-oil',
  'icon-last-stop',
  'icon-point',
  'icon-data-extractor',
  'icon-alarms',
  'shape-solar',
  'shape-water-turbine',
  'shape-wind-turbine',
  'icon-pales',
  'icon-hydro',
  'icon-solar',
  'icon-toggle-off',
  'icon-toggle-on'
]

export default {
  name: 'Icon',
  props: {
    name: { type: String, required: true }
  },
  computed: {
    isSVG: function () {
      return svgIcons.indexOf(this.name) !== -1
    }
  },
  methods: {
    svgIconList: () => {
      return svgIcons
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generics/Icon.vue